import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Navigation, Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import EventCard from "./cards/EventCard";
import { nanoid } from "nanoid";
import darkTheme from "../src/theme";
import axios from "axios";
import Skeleton from "@mui/material/Skeleton";

let skeletonCards = Array(30).fill(0);

const clubsContainer = {
  marginTop: darkTheme.spacing(7),
  marginBottom: darkTheme.spacing(3),
  [darkTheme.breakpoints.down("md")]: {
    marginBottom: darkTheme.spacing(0),
    marginTop: darkTheme.spacing(0),
    paddingBottom: darkTheme.spacing(0),
  },
  "& h2": {
    fontSize: 22,
    [darkTheme.breakpoints.down("md")]: {
      marginBottom: darkTheme.spacing(1),
      marginTop: darkTheme.spacing(1),
      fontSize: 18,
      paddingBottom: darkTheme.spacing(0),
    },
  },
  [darkTheme.breakpoints.down("md")]: {
    marginBottom: darkTheme.spacing(1),
    marginTop: darkTheme.spacing(3),
    "& h4": {
      textTransform: "capitalize !important",
    },
  },
};

function HomeEvents(props) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const mainLogic = async () => {
    await axios
      .get(
        `/api/events/events?slug=${props.slug}&id=${props.id}&page=relatedEvents&city=${props.city}`,
        {
          headers: {
            "x-auth-token": process.env.JWT_TOKEN,
          },
        }
      )
      .then((response) => {
        if (response.status == 200) {
          setEvents(response.data.result);
          setLoading(false);
        }
      });
    };

    mainLogic();
  }, [props.id]);

  return (
    <>
      {loading ? (
        <Typography component="div" sx={clubsContainer}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={20}
            width={300}
            sx={{ mb: 3 }}
          />
          <Grid container spacing={0}>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              spaceBetween={25}
              navigation
              autoplay={true}
              loop={false}
              slidesPerView={1.25}
              breakpoints={{
                1023: {
                  width: 1023,
                  slidesPerView: 4,
                },
                990: {
                  width: 990,
                  slidesPerView: 3,
                },
                768: {
                  width: 768,
                  slidesPerView: 2.25,
                },
                425: {
                  width: 425,
                  slidesPerView: 1.25,
                },
              }}
            >
              {skeletonCards.map((index) => (
                <SwiperSlide>
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    height={300}
                    sx={{ borderRadius: darkTheme.spacing(1) }}
                    key={"sk" + index}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Typography>
      ) : (
        <>
          {events.length > 0 ? (
            <Typography component="div" sx={clubsContainer}>
              {/* <Typography variant="h2" sx={{ pb: 3 }}>Discover Similar {props.type} Events <Typography variant="span" sx={{ textTransform: 'capitalize !important' }}>{`in ${cityName}`}</Typography></Typography> */}
              <Typography variant="h2" sx={{ pb: 3 }}>
                You May Like
              </Typography>
              <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={25}
                navigation
                autoplay={false}
                loop={false}
                slidesPerView={1.25}
                breakpoints={{
                  1023: {
                    width: 1023,
                    slidesPerView: 4,
                  },
                  990: {
                    width: 990,
                    slidesPerView: 3,
                  },
                  768: {
                    width: 768,
                    slidesPerView: 2.25,
                  },
                  425: {
                    width: 425,
                    slidesPerView: 1.25,
                  },
                }}
              >
                {events.map((event) => (
                  <Grid
                    item
                    xs={12}
                    sm={4}
                    md={3}
                    lg={3}
                    xl={3}
                    key={nanoid(30)}
                  >
                    <SwiperSlide key={event.id}>
                      <EventCard data={event} key={event.id} />
                    </SwiperSlide>
                  </Grid>
                ))}
              </Swiper>
            </Typography>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
}

export default HomeEvents;
